import { render } from "./ItemTreeIndex.vue?vue&type=template&id=5dc4811f&scoped=true&ts=true"
import script from "./ItemTreeIndex.vue?vue&type=script&lang=ts"
export * from "./ItemTreeIndex.vue?vue&type=script&lang=ts"

import "./ItemTreeIndex.vue?vue&type=style&index=0&id=5dc4811f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc4811f"]])

export default __exports__